// extracted by mini-css-extract-plugin
module.exports = {"svg-grayscale":"integrations_svg-grayscale__4aigd","svg-invert":"integrations_svg-invert__3obs0"};